import {
  FIVE9_CALL_QUEUE_PREFIX,
  FIVE9_CALL_QUEUE_VERSION
} from 'src/constants/five9CallApi';

export const five9CallQueueStorageKeyFor = (identity) => (
  `${FIVE9_CALL_QUEUE_PREFIX}:v${FIVE9_CALL_QUEUE_VERSION}:${encodeURIComponent(String(identity))}`
);

const removeMatchingKeys = (storage, identity) => {
  if (!storage) return;
  const exactKey = identity ? five9CallQueueStorageKeyFor(identity) : null;
  const prefix = `${FIVE9_CALL_QUEUE_PREFIX}:`;
  try {
    if (exactKey) {
      storage.removeItem(exactKey);
      return;
    }
    const keys = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key && key.startsWith(prefix)) keys.push(key);
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch (_) {
    // Storage cleanup must never block auth transitions or SDK callbacks.
  }
};

export const clearPersistedFive9CallQueues = (identity) => {
  if (typeof sessionStorage !== 'undefined') removeMatchingKeys(sessionStorage, identity);
  // Legacy cleanup: early DD2-6465 builds used localStorage. Remove those
  // copies too so auth transitions purge previously persisted PII.
  if (typeof localStorage !== 'undefined') removeMatchingKeys(localStorage, identity);
};
